import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { configuration } from 'src/environments/environment';
import { IPayerAddressBook } from 'src/app/models/IPayerAddressBook';

@Injectable({
  providedIn: 'root'
})
export class PayerAddressBookService {

  constructor(private http: HttpClient) { }

  // Get the address book (Primary/Secondary/Tertiary + purpose-specific addresses) for one or more
  // Master Payers - insuranceCarrierId accepts a single id (123) or a comma-separated list
  // ("101,205,318") / array of ids, matching USP_EMR_GET_PAYER_ADDRESS_BOOK's @InsuranceCarrierId
  // contract. facility (already sent below) now actually scopes the result on the backend.
  getPayerAddressBook(insuranceCarrierId: number | string | number[], includeInactive: boolean = false): Observable<IPayerAddressBook[]> {
    const carrierIds = Array.isArray(insuranceCarrierId) ? insuranceCarrierId.join(',') : insuranceCarrierId;
    return this.http.get<IPayerAddressBook[]>(`${configuration.apiUrl + 'Master/PayerAddressBook'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}&&insuranceCarrierId=${carrierIds}&&includeInactive=${includeInactive}`);
  }

  // Add a new address to a Master Payer's Address Book (maps to USP_EMR_ADD_PAYER_ADDRESS)
  addPayerAddress(address: IPayerAddressBook): Observable<{ message: string, newBookId: number }> {
    return this.http.post<{ message: string, newBookId: number }>(`${configuration.apiUrl + 'Master/PayerAddress'}`, address, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Close out an existing address and add its replacement in one transaction (maps to USP_EMR_SUPERSEDE_PAYER_ADDRESS)
  supersedeAddress(bookId: number, address: IPayerAddressBook): Observable<string> {
    const modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    return this.http.put<string>(`${configuration.apiUrl + 'Master/PayerAddress/Supersede'}?bookId=${bookId}&&modifiedBy=${modifiedBy}`, address, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Resolve the currently effective address for a Master Payer (optionally starting from a specific address book entry)
  resolvePayerAddress(insuranceCarrierId: number, addressBookId?: number): Observable<IPayerAddressBook> {
    return this.http.get<IPayerAddressBook>(`${configuration.apiUrl + 'Master/ResolvePayerAddress'}?insuranceCarrierId=${insuranceCarrierId}&&addressBookId=${addressBookId || ''}`);
  }

  // Toggle an address book entry between ACTIVE and INACTIVE (maps to USP_EMR_SET_PAYER_ADDRESS_STATUS)
  setAddressStatus(bookId: number, status: 'ACTIVE' | 'INACTIVE'): Observable<string> {
    const modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    return this.http.put<string>(`${configuration.apiUrl + 'Master/PayerAddress/Status'}?bookId=${bookId}&&status=${status}&&modifiedBy=${modifiedBy}`, {});
  }
}
